import { render } from "./DelivererDashboard.vue?vue&type=template&id=5691fbb1&scoped=true"
import script from "./DelivererDashboard.vue?vue&type=script&lang=js"
export * from "./DelivererDashboard.vue?vue&type=script&lang=js"

import "./DelivererDashboard.vue?vue&type=style&index=0&id=5691fbb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5691fbb1"]])

export default __exports__